export const documentType = Object.freeze({
	ID_CARD: "ID_CARD",
	PILOT_CERTIFICATE: "PILOT_CERTIFICATE",
	EMERGENCY_CONTACT: "EMERGENCY_CONTACT",
});

export type TDocumentType = (typeof documentType)[keyof typeof documentType];
